module.exports = __webpack_public_path__ + "img/img_user_3.8bfce495.png";